
<div v-if="audit">
    <f-dialog
        :title  = "$t('audit.rebuild.query')"
        v-model = "confirmRebuild"
        :width  = "450"
        store-label="Berichte erstellen"
        :show-cancel = "false"
        @cancel = "onCancelRebuild"
        @store  = "onRebuild"
    >
        <template v-slot:preaction>
            <div class="text-center w-100">
                <v-switch
                    v-if    = "!gbuIsEscalator"
                    v-model = "recalculate"
                    :label  = "$t('audit.rebuild.label')"
                    :ripple = "false"
                    class   = "pt-0 mt-0"
                    hide-details
                />
            </div>
        </template>

        <template v-slot:content>
            <div class="pa-2" v-html="$t('audit.rebuild.text')"></div>
            <div class="pa-2 mb-2" v-if="!gbuIsEscalator" v-html="$t('audit.rebuild.recalculate')"></div>
        </template>
    </f-dialog>

    <p-audit-history
        v-model      = "delta.show"
        :audit       = "delta.audit"
        :type        = "delta.type"
        :device-type = "delta.deviceType"
    />

    <v-row class="no-frame mt-2">
        <v-col class="pa-0 no-border" :class="showEsg ? 'main-first-2-col pr-3' : ''">
            <c-audit-overview
                class             = "h-100"
                :data             = "audit.gbu"
                :country          = "unit.country.iso3166"
                :height           = "690"
                type              = "GBU"
                :device-type      = "gbuDeviceType"
                :show-budget-data = "true"
            >
                <template v-slot:toolbar>
                    <div class="v-flex white--text mr-3" v-if="audit.gbu">
                        {{ audit.user }}
                        <div class="mr-2">
                            {{ formatDate (audit.gbu.date) }}
                        </div>
                        <div>
                            {{ audit.gbu.user ? audit.gbu.user.surname : '---' }}
                        </div>
                    </div>
                </template>

                <template v-slot:overlay>
                    <div>
                        <c-fab-menu
                            icon     = "mdi-history"
                            :label   = "$t('audit.history')"
                            :menu    = "history.gbu"
                            :columns = "2"
                            @entry   = "onGbuSelected"
                        />
                    </div>

                    <div class="mt-3" v-if="isPlanner">
                        <c-fab-button
                            icon     = "mdi-delta"
                            :label   = "$t('audit.delta.label')"
                            @click   = "onGbuDelta"
                        />
                    </div>

                    <div class="mt-3">
                        <c-fab-menu
                            icon     = "mdi-printer"
                            :label   = "$t('audit.report.title')"
                            :menu    = "reports.gbu"
                            :columns = "1"
                            @entry   = "onGbuReport"
                        />
                    </div>

                    <div class="mt-3" v-if="isPlanner && !gbuIsEscalator">
                        <c-fab-menu
                            icon     = "mdi-calculator"
                            :label   = "$t('audit.recalc.title')"
                            :menu    = "calculator.gbu"
                            :columns = "1"
                            @entry   = "onGbuRecalc"
                        />
                    </div>
                </template>
            </c-audit-overview>
        </v-col>
        <v-col class="main-first-2-col pa-0 pl-3 no-border" v-if="showEsg">
            <c-audit-overview
                class             = "h-100"
                :data             = "audit.esg"
                :height           = "690"
                :country          = "unit.country.iso3166"
                type              = "ESG"
                :show-budget-data = "true"
            >
                <template v-slot:toolbar>
                    <div class="v-flex white--text mr-3" v-if="audit.esg">
                        <div class="mr-2">
                            {{ formatDate (audit.esg.date) }}
                        </div>
                        <div>
                            {{ audit.esg.user ? audit.esg.user.surname : '---' }}
                        </div>
                    </div>
                </template>
                <template v-slot:overlay>
                    <div>
                        <c-fab-menu
                            icon     = "mdi-history"
                            :label   = "$t('audit.history')"
                            :menu    = "history.esg"
                            :columns = "2"
                            @entry   = "onEsgSelected"
                        />
                    </div>

                    <div class="mt-3" v-if="isPlanner">
                        <c-fab-button
                            icon     = "mdi-delta"
                            :label   = "$t('audit.delta.label')"
                            @click   = "onEsgDelta"
                        />
                    </div>

                    <div class="mt-3">
                        <c-fab-menu
                            icon     = "mdi-printer"
                            :label   = "$t('audit.report.title')"
                            :menu    = "reports.esg"
                            :columns = "1"
                            @entry   = "onEsgReport"
                        />
                    </div>
                </template>
            </c-audit-overview>
        </v-col>
    </v-row>
</div>
